import { withStyles } from '@material-ui/core';

import ErrorMessage from './component';
import styles from './styles';

export default withStyles(styles)(ErrorMessage);
